import {
    buildRecordLifecyclePagedListActions,
    type RecordLifecycleConfirmKind,
} from "../../utils/navigation/recordLifecycleActions";
import type { IWasteMovementListRow } from "../../customTypings/wasteMovement/WasteMovement";

export type WasteMovementAdminConfirmKind = RecordLifecycleConfirmKind;

export function formatWasteMovementToastLabel(reference: string | null | undefined, ewcCode: string | undefined): string {
    const ref = typeof reference === "string" ? reference.trim() : "";
    if (ref.length > 0) return ref;
    const ewc = typeof ewcCode === "string" ? ewcCode.trim() : "";
    return ewc.length > 0 ? ewc : "Waste movement";
}

export function getWasteMovementAdminActionSuccessMessage(
    kind: WasteMovementAdminConfirmKind,
    reference: string | null | undefined,
    ewcCode?: string
): string {
    const label = formatWasteMovementToastLabel(reference, ewcCode);
    const successByKind: Record<WasteMovementAdminConfirmKind, string> = {
        disable: `${label} disabled successfully!`,
        enable: `${label} enabled successfully!`,
        softDelete: `${label} deleted successfully!`,
        restore: `${label} restored successfully!`,
    };
    return successByKind[kind];
}

const SITE_NOT_OPERATIONALLY_ELIGIBLE = "siteNotOperationallyEligible";

export function buildWasteMovementAdminPagedListActions(
    openConfirm: (kind: WasteMovementAdminConfirmKind, item: IWasteMovementListRow) => void
) {
    return buildRecordLifecyclePagedListActions<IWasteMovementListRow>(openConfirm).map((action) => ({
        ...action,
        hideWhenMembers: [
            ...(action.hideWhenMember ? [action.hideWhenMember] : []),
            SITE_NOT_OPERATIONALLY_ELIGIBLE,
        ],
        hideWhenMember: undefined,
    }));
}

export { canMutateWasteMovements } from "@/features/wasteMovement/core/wasteMovementFormAccess";
